// Change name to "cookie" for next April Fool's (idea by NG on 4/24/2021)

const name = {
  business: "uncookd LLC",
  main: "uncookd",
  full: "[uncookd]",
  short: "[u]",
};

module.exports = name;
